import { cloneDeep } from 'lodash';
const SET_URL_PARAMS = 'SET_URL_PARAMS';
const urlParamsInitialState = [];

export default function reducer(state = cloneDeep(urlParamsInitialState), action) {
	switch (action.type) {
		case SET_URL_PARAMS:
			return [...action.payload];
		default:
			return state;
	}
}


export function initializeUrlParams( params={} ){
	let urlParams = [];
	if(params.url1) urlParams.push(params.url1);
	if(params.url2) urlParams.push(params.url2);
	return setUrlParams(urlParams);
}

export function setUrlParams( params ){
	return {
		type: SET_URL_PARAMS,
		payload: params
	};
}


// WEBPACK FOOTER //
// ./src/modules/url_params.js